import { HubConnection, HubConnectionBuilder, LogLevel } from "@aspnet/signalr"

export default class HubRecordViewService {
	private connectionShouldBeOpen: boolean = false;
	private connection: HubConnection | null = null;

	public async openConnection (viewId: string): Promise<HubConnection> {
		if (this.connection) {
			this.connection.invoke("leaveRecordView")
			this.connection.stop()
			this.connection = null
		}

		const connection = new HubConnectionBuilder()
			.withUrl(`${process.env.VUE_APP_HTTP_API_URI}record-view-hub`)
			.configureLogging(LogLevel.Information)
			.build()

		let startedPromise = null

		const start: () => Promise<any> = () => {
			startedPromise = connection.start()
				.then(() => {
					connection.invoke("joinRecordView", viewId)
				})
				.catch(err => {
					console.error("HubRecordViewService - failed to connect with hub:", err)

					return new Promise((resolve, reject) =>
						setTimeout(() => start()
							.then(resolve)
							.catch(reject),
						5000))
				})

			return startedPromise
		}

		connection.onclose(() => {
			if (this.connectionShouldBeOpen) {
				start()
			}
		})

		this.connectionShouldBeOpen = true
		await start()
		this.connection = connection

		return this.connection
	}

	public closeConnection () {
		if (this.connection) {
			this.connectionShouldBeOpen = false
			console.log("Leaving record view service")

			this.connection.stop()
			this.connection = null
		}
	}
}
